import API from '../api/axios';

// 获取用户信息（不存 Redux，直接返回数据）
export const getUserInfo = async () => {
  try {
    const response = await API.post('/users/me');
    return response.data; // 只返回 user
  } catch (error) {
    console.error('获取用户信息失败', error);
    return null;
  }
};
